import { DateTime } from 'luxon';
import { DateTimeString } from './date-time-string';

/**
 * Gets the Date object for a given DateTimeString.
 *
 * @param date - the DateTimeString to get the Date for
 * @returns - Date
 */
export function getDateFromDateTimeString(date: DateTimeString): Date {
    return DateTime.fromISO(date).toJSDate();
}
